var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "-1 -1 14 14",
    height: 14,
    width: 14,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "delete-1--remove-add-button-buttons-delete-cross-x-mathematics-multiply-math"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    stroke: "#4b5168",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m11.571428571428573 0.4285714285714286 -11.142857142857144 11.142857142857144",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    stroke: "#4b5168",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m0.4285714285714286 0.4285714285714286 11.142857142857144 11.142857142857144",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.6dbf5bc369e60a3cdca13ddaf81dbf72.svg";
export { ForwardRef as ReactComponent };